import PropTypes from 'prop-types';

export const IMAGE_SHAPE = PropTypes.shape({
    name: PropTypes.string,
    source: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    size: PropTypes.number,
    mediaId: PropTypes.string
});

const CROP_DATA_SHAPE = {
    percentCrop: PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number,
        height: PropTypes.number,
        width: PropTypes.number
    })
};

export const CROPPED_IMAGE_SHAPE = PropTypes.shape({
    name: PropTypes.string,
    source: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    size: PropTypes.number,
    mediaId: PropTypes.string,
    percentCrop: PropTypes.shape(
        {
            ...CROP_DATA_SHAPE
        }
    ),
    pixelCrop: PropTypes.shape(
        {
            ...CROP_DATA_SHAPE
        }
    )
});

export const UPLOAD_MANAGER_SHAPE = PropTypes.shape({
    addTask: PropTypes.func
});
